/* NATUPHARMA — theme behaviour */
(function () {
  'use strict';

  var inEditor = window.Shopify && window.Shopify.designMode;

  function each(root, sel, fn) {
    (root || document).querySelectorAll(sel).forEach(fn);
  }
  /* run once per element */
  function once(el, key) {
    if (el.dataset['b_' + key]) return false;
    el.dataset['b_' + key] = '1';
    return true;
  }

  /* Mobile nav toggle */
  function initNav(root) {
    each(root, '[data-nav-toggle]', function (btn) {
      if (!once(btn, 'nav')) return;
      btn.addEventListener('click', function () {
        var nav = document.querySelector(btn.getAttribute('data-nav-toggle'));
        if (nav) {
          var open = nav.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      });
    });
  }

  /* Quantity steppers */
  function initQty(root) {
    each(root, '[data-qty]', function (el) {
      if (!once(el, 'qty')) return;
      var input = el.querySelector('input');
      el.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* Collection filter (front-end demo; Shopify handles real filtering server-side) */
  function initFilter(root) {
    each(root, '[data-filter-bar]', function (bar) {
      if (!once(bar, 'filter')) return;
      var grid = document.querySelector(bar.getAttribute('data-target') || '');
      bar.querySelectorAll('[data-filter]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          bar.querySelectorAll('[data-filter]').forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          if (!grid) return;
          var val = pill.getAttribute('data-filter');
          grid.querySelectorAll('[data-cat]').forEach(function (card) {
            var show = val === '*' || card.getAttribute('data-cat') === val;
            card.style.display = show ? '' : 'none';
          });
        });
      });
    });
  }

  /* Product image gallery */
  function initGallery(root) {
    each(root, '[data-gallery]', function (g) {
      if (!once(g, 'gallery')) return;
      var slides = g.querySelectorAll('[data-slide]');
      var thumbs = g.querySelectorAll('[data-thumb]');
      var prev = g.querySelectorAll('[data-gallery-prev]');
      var next = g.querySelectorAll('[data-gallery-next]');
      if (slides.length < 2) {
        prev.forEach(function (b) { b.style.display = 'none'; });
        next.forEach(function (b) { b.style.display = 'none'; });
        return;
      }
      var i = 0;
      function show(k) {
        i = (k + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
        thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      }
      prev.forEach(function (b) { b.addEventListener('click', function () { show(i - 1); }); });
      next.forEach(function (b) { b.addEventListener('click', function () { show(i + 1); }); });
      thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { show(idx); }); });
    });
  }

  function initBannerSlider(root) {
    each(root, '[data-banner-slider]', function (sl) {
      if (!once(sl, 'banner')) return;
      var track = sl.querySelector('.bannerslider__track');
      var slides = sl.querySelectorAll('[data-banner-slide]');
      var dots = sl.querySelectorAll('[data-banner-dot]');
      if (slides.length < 2 || !track) return;
      var interval = parseFloat(sl.getAttribute('data-interval')) || 0;
      var i = 0, timer = null;
      function go(k) {
        i = (k + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      }
      function start() { if (interval > 0 && !inEditor) { timer = setInterval(function () { go(i + 1); }, interval * 1000); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }
      sl.querySelectorAll('[data-banner-prev]').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); restart(); }); });
      sl.querySelectorAll('[data-banner-next]').forEach(function (b) { b.addEventListener('click', function () { go(i + 1); restart(); }); });
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); restart(); }); });
      sl.addEventListener('mouseenter', stop);
      sl.addEventListener('mouseleave', start);
      start();
    });
  }

  function initAnnounce(root) {
    each(root, '[data-announce-rotator]', function (r) {
      if (!once(r, 'announce')) return;
      var msgs = r.querySelectorAll('[data-announce-msg]');
      if (msgs.length < 2) return;
      var interval = parseFloat(r.getAttribute('data-interval')) || 4;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, interval * 1000);
    });
  }

  function initInteractive(root) {
    initNav(root);
    initQty(root);
    initFilter(root);
    initGallery(root);
    initBannerSlider(root);
    initAnnounce(root);
  }

  /* Reveal all data-reveal elements inside a root (used in editor + section reloads) */
  function revealIn(root) {
    each(root, '[data-reveal]', function (el) { el.classList.add('is-in'); });
  }

  /* Reveal on scroll (progressive enhancement). Disabled in the theme editor so
     editing a section never leaves freshly-rendered content hidden. */
  function initReveal() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length) return;
    if (inEditor || !('IntersectionObserver' in window)) {
      revealIn(document); // never hide in the editor / unsupported browsers
      return;
    }
    document.documentElement.classList.add('js-reveal');

    function reveal(el) { el.classList.add('is-in'); }
    function inView(el) {
      var r = el.getBoundingClientRect();
      return r.top < (window.innerHeight || 0) && r.bottom > 0;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

    items.forEach(function (el) {
      if (inView(el)) { reveal(el); } else { io.observe(el); }
    });

    setTimeout(function () {
      document.querySelectorAll('[data-reveal]:not(.is-in)').forEach(reveal);
    }, 1400);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initInteractive(document);
    initReveal();
  });

  /* Shopify theme editor: re-wire and reveal a section when it is added/edited */
  if (inEditor) {
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target || document;
      revealIn(root);
      initInteractive(root);
    });
    document.addEventListener('shopify:section:select', function (e) {
      revealIn(e.target || document);
    });
    document.addEventListener('shopify:block:select', function (e) {
      revealIn(document);
    });
  }
})();
